import {
  getSectionFullCode,
  prepareSectionMetadata,
} from '../../../actions/helpers/section.helper';
import { createSectionApi, updateSectionApi } from '../../../api/sections';
import { clearSurveyCacheApi } from '../../../api/surveys';

// Saves a section rename: creates the metadata entry when the section has none
// yet (Id === -1), updates it otherwise, then clears the survey cache.
// Returns the updated selected-section object for the caller's local state.
const saveSurveySection = async ({ sectionInfo, selectedSection, survey, jwt }) => {
  const codeWithSurveyData = getSectionFullCode(sectionInfo.code, survey);
  const normalizedCode = sectionInfo.code?.split('#')?.[0] ?? sectionInfo.code;

  const sectionPayload = {
    ...selectedSection.Data,
    name: sectionInfo.title,
    code: codeWithSurveyData,
  };

  if (selectedSection.Id === -1) {
    await createSectionApi(sectionPayload, jwt);
  } else {
    const updatePayload = prepareSectionMetadata(sectionPayload, selectedSection.Data, survey);
    await updateSectionApi(selectedSection.Id, updatePayload, jwt);
  }

  await clearSurveyCacheApi(survey.id, jwt);

  const finalMetadata = prepareSectionMetadata(
    {
      ...selectedSection.Data,
      name: sectionInfo.title,
      code: normalizedCode,
    },
    selectedSection.Data,
    survey
  );

  return {
    ...selectedSection,
    Data: {
      ...finalMetadata,
      code: normalizedCode,
    },
  };
};

export default saveSurveySection;
